import * as React from 'react';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from 'styled-components';

import { ReactHelmet } from '@utils/react-helmet';

import { ModalProvider } from '@shared/contexts';
import { GlobalStyles } from '@shared/styled-system';

import { useMutationOttAuthorization } from '@hooks/api/auth/use-mutation-ott-authorization.tsx';
import { useCustomTheme } from '@hooks/use-custom-theme.ts';
import useIsInIframe from '@hooks/use-is-in-iframe';

import { AppRoutes } from '@components/app-routes';

import '@assets/fonts/index.css';

const App = () => {
	const { mutate: ottAuthorization } = useMutationOttAuthorization();
	const theme = useCustomTheme();
	const isIframe = useIsInIframe();

	React.useEffect(() => {
		ottAuthorization();
	}, []);

	return (
		<ThemeProvider theme={theme}>
			<GlobalStyles />
			<ReactHelmet />
			<ModalProvider>
				<AppRoutes />
			</ModalProvider>
			<div className={`toast_wrapper ${isIframe && 'toast_wrapper_iframe'}`}>
				<ToastContainer autoClose={5000} hideProgressBar closeOnClick />
			</div>
		</ThemeProvider>
	);
};

export default App;
